/** Resolve once an element is actually visible, so chart draw animations are seen. */
export function whenInViewport(element, { threshold = 0.18 } = {}) {
  if (!element || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      resolve();
    }, { threshold, rootMargin: '0px 0px -8% 0px' });
    observer.observe(element);
  });
}
